// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { asterisk5X5 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-asterisk': IconAsterisk;
    }
}

/**
 * The icon component for the 'asterisk' icon
 */
export class IconAsterisk extends Icon {
    public constructor() {
        super(asterisk5X5);
    }
}

registerIcon('icon-asterisk', IconAsterisk);
export const iconAsteriskTag = 'nimble-icon-asterisk';
